// const Server = 'http://pt.local'
const Server = 'https://service.myjkyt.cn'

module.exports = {
  UNION_PAY_PREFIX: Server + '/pay/union/',
  host: Server + '/api/all/' // http://hospitaldev.ngrok.cc/api/wechat
}



// WEBPACK FOOTER //
// ./src/api/base.js